import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import React from "react";
import appcolors from "../../constants/Colors";
import { allImages } from "../../assets";
import LanguageMenu from "../LanguageMenu";
import { t } from "i18next";

const Container = styled(Box)(({ theme }) => ({
  background: theme.palette.gradient.authBg,
  position: "relative",
  minHeight: "80vh",
  width: "90%",
  margin: "auto",
  boxShadow: "10px 10px 60px 0px #00000040",
  borderRadius: "25px",
  margin: "24px",

  // marginTop: "10rem",
  [theme.breakpoints.down("md")]: {
    minHeight: "auto",
    width: "100%",
    borderRadius: "0px",
    margin: "0px",
  },
}));

const LeftGridItem = styled(Grid)(({ theme }) => ({
  padding: 16,
  position: "relative",
  zIndex: 999,
}));

const RightGridItem = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.custom.white,
  padding: 24,
  borderRadius: "25px",
  minHeight: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    borderRadius: "0px",
    padding: "24px 8px",
    minHeight: "auto",
  },
}));

const LogoTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1.875rem",
  fontWeight: 600,
  color: appcolors.white,
}));

const SubtitleTypography = styled(Typography)(({ theme }) => ({
  marginTop: 24,
  fontWeight: 600,
  color: theme.palette.custom.softGrey,
  textTransform: "capitalize",
  fontSize: "1.785rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "2.188rem",
  },
}));

const AuthContainer = ({ children }) => {
  return (
    <Box
      // mt={{xs:5,md:2}}
      minHeight={"100vh"}
      position={"relative"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        backgroundImage: `url(${allImages.authMainBgImg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Grid container>
          <LeftGridItem item xs={12} md={5}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <LogoTypography variant="h1">Eaziday</LogoTypography>

              <LanguageMenu iconColor={"#fff"} />
            </Stack>
            {/* <Typography variant="body2" color={appcolors.white}>
              {t("poweredBy")}
            </Typography> */}
            <SubtitleTypography variant="h1">{t("tagline")}</SubtitleTypography>
            <Typography variant="body2" color={appcolors.white}>
              {t("ourAmbition")}
            </Typography>
            <img
              src={allImages.authBgImg}
              alt="auth-image"
              width={"100%"}
              // height={"100%"}
            />
          </LeftGridItem>
          <RightGridItem item xs={12} md={7}>
            {children}
          </RightGridItem>
        </Grid>
      </Container>
    </Box>
  );
};

export default AuthContainer;
